
<view-linkable :content-element="contentElement" :entry="entry">
  <blank-fallback :isBlank="isBlankHtml(html)">
    <div v-html="html"></div>
  </blank-fallback>
</view-linkable>
